<template>
    <div class="c-label" :class="classes">
        {{status.label}}
    </div>
</template>

<script>
export default {
    props: {
        target: {
            required: true
        },
        assignment: {
            type:Boolean,
            required: false
        },
        label: {
            type:Boolean,
            required: false
        }
    },
    computed: {
        status() {

            if ( this.assignment ) {

                if ( this.target.afgekeurd_at ) {
                    return { label: 'Afgekeurd', color: 'tertiary'};
                }
                else if ( this.target.klaar_at ) {
                    return { label: 'Gereed', color: 'success'};
                }
                else if ( this.target.afgewezen_at ) {
                    return { label: 'Afgewezen', color: 'alert'};
                }
                else if ( this.target.ingetrokken_at ) {
                    return { label: 'Geannuleerd', color: 'alert'};
                }
                else if ( this.target.geaccepteerd_at ) {
                    return { label: 'In afwachting', color: 'warning' };
                }
                else if ( this.target.is_verlopen ) {
                    return { label: 'Verlopen', color: 'warning'};
                }
                else {
                    return { label: 'Verzoek', color: 'secondary' };
                }
            }
            else {
                
                switch (this.target.status.toLowerCase()) {
                    case 'afgerond':
                    case 'gereed':
                    case 'ready':
                            return { label: this.target.status, color: 'success'};
                        break;
                    case 'in uitvoering':
                    case 'in progress':
                            return { label: this.target.status, color: 'warning'};
                        break;

                    case 'geannuleerd':
                    case 'cancelled':
                            return { label: this.target.status, color: 'alert'};
                        break;

                    case 'verzoek':
                    case 'new':
                            return { label: this.target.status, color: 'secondary'};
                        break;
                    case 'afgekeurd':
                            return { label: this.target.status, color: 'tertiary'};
                        break;
                }
            }
        },
        classes() {
            return ( this.label ) ?
                ['c-label', 'c-label--' + this.status.color].join(' ') :
                ['tt-uppercase','fw-medium','fs-xsmall', 'color-' + this.status.color].join(' ');
        }
    }
}
</script>
